var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnCarInterior(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "198px",
    height: "198px",
    viewBox: "-32 -32 128.00 128.00",
    id: "Layer_1_1_",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    stroke: "#000000",
    strokeWidth: 0.00064,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    x: -32,
    y: -32,
    width: 128,
    height: 128,
    rx: 64,
    fill: "#DA4A5A",
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37,5H27v6h10V5z M35,9h-6V7h6V9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,53h-8c-2.191,0-4.285,1.047-5.601,2.801L21.2,57.4l1.6,1.199l1.199-1.599C24.939,55.748,26.435,55,28,55h8 c1.565,0,3.061,0.748,4.001,2l1.199,1.6l1.6-1.199L41.601,55.8C40.285,54.047,38.191,53,36,53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,47h-1.5l0.8-1.829c1.128-2.631,1.7-5.417,1.7-8.281c0-1.318-0.125-2.642-0.371-3.933L46.911,18.69 c-0.58-3.044-3.094-5.291-6.116-5.623C40.922,12.735,41,12.377,41,12V4c0-1.654-1.346-3-3-3H26c-1.654,0-3,1.346-3,3v8 c0,0.377,0.078,0.734,0.205,1.067c-3.022,0.332-5.537,2.58-6.116,5.623l-2.718,14.266C14.125,34.248,14,35.571,14,36.89 c0,2.864,0.572,5.65,1.7,8.281L16.485,47H15c-1.654,0-3,1.346-3,3v8c0,2.757,2.243,5,5,5h30c2.757,0,5-2.243,5-5v-8 C52,48.346,50.654,47,49,47z M44.946,19.064l2.718,14.267C47.887,34.5,48,35.697,48,36.89c0,2.592-0.518,5.112-1.538,7.494 l-1.355,3.168l-0.12,0.24C44.385,48.341,44,49.123,44,50v2.452c-0.599-0.633-1.276-1.179-2-1.65V15.42 C43.488,16.061,44.628,17.393,44.946,19.064z M24,21h16v4H24V21z M40,41.586L37.914,39.5L40,37.414V41.586z M32,27.414l3.086,3.086 L32,33.586L28.914,30.5L32,27.414z M27.5,29.086L25.414,27h4.172L27.5,29.086z M34.414,27h4.172L36.5,29.086L34.414,27z M30.586,35 L27.5,38.086L24.414,35l3.086-3.086L30.586,35z M32,36.414l3.086,3.086L32,42.586L28.914,39.5L32,36.414z M33.414,35l3.086-3.086 L39.586,35L36.5,38.086L33.414,35z M40,32.586L37.914,30.5L40,28.414V32.586z M24,28.414l2.086,2.086L24,32.586V28.414z M24,37.414 l2.086,2.086L24,41.586V37.414z M27.5,40.914L29.586,43h-4.172L27.5,40.914z M36.5,40.914L38.586,43h-4.172L36.5,40.914z M40,15v4 H24v-4h2h12H40z M24,45h16v4.773C38.736,49.277,37.383,49,36,49h-8c-1.383,0-2.736,0.277-4,0.773V45z M25,4c0-0.551,0.448-1,1-1h12 c0.552,0,1,0.449,1,1v8c0,0.551-0.448,1-1,1H26c-0.552,0-1-0.449-1-1V4z M16.336,33.331l2.718-14.267 c0.318-1.671,1.458-3.004,2.946-3.644v35.382c-0.724,0.471-1.401,1.017-2,1.65V50c0-0.869-0.377-1.645-0.968-2.194l-1.493-3.423 C16.518,42.002,16,39.481,16,36.89C16,35.697,16.113,34.5,16.336,33.331z M50,58c0,1.654-1.346,3-3,3H17c-1.654,0-3-1.346-3-3v-8 c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1v5h2.5l0.3-0.399C22.491,52.346,25.183,51,28,51h8c2.817,0,5.509,1.346,7.2,3.601 L43.5,55H46v-5c0-0.552,0.448-1,1-1h2c0.552,0,1,0.448,1,1V58z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnCarInterior);
export default __webpack_public_path__ + "static/media/icn_car_interior.dbe7559e663aa7e1f5855427ff18a1af.svg";
export { ForwardRef as ReactComponent };